import { useMediaQuery } from '@chakra-ui/react';
import {
  BREAKPOINT_2XL_MIN,
  BREAKPOINT_LG_MAX,
  BREAKPOINT_LG_MIN,
  BREAKPOINT_MD_MAX,
  BREAKPOINT_MD_MIN,
  BREAKPOINT_SM_MAX,
  BREAKPOINT_SM_MIN,
  BREAKPOINT_XL_MAX,
  BREAKPOINT_XL_MIN,
  BREAKPOINT_XS_MAX,
} from '../constants/constants';

export type Breakpoint = 'base' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export type BreakpointOptions = {
  [key in Breakpoint]?: string;
};

export type BreakpointResult<T = object> = {
  [key in Breakpoint]?: T;
};

export const useBreakpoint = <T>(
  breakpointValues?: BreakpointResult,
  options: BreakpointOptions = {}
): T => {
  const [xs] = useMediaQuery(
    options['xs'] || `(max-width: ${BREAKPOINT_XS_MAX})`
  );
  const [sm] = useMediaQuery(
    options['sm'] ||
      `(min-width: ${BREAKPOINT_SM_MIN}) and (max-width: ${BREAKPOINT_SM_MAX})`
  );
  const [md] = useMediaQuery(
    options['md'] ||
      `(min-width: ${BREAKPOINT_MD_MIN}) and (max-width: ${BREAKPOINT_MD_MAX})`
  );
  const [lg] = useMediaQuery(
    options['lg'] ||
      `(min-width: ${BREAKPOINT_LG_MIN}) and (max-width: ${BREAKPOINT_LG_MAX})`
  );
  const [xl] = useMediaQuery(
    options['xl'] ||
      `(min-width: ${BREAKPOINT_XL_MIN}) and (max-width: ${BREAKPOINT_XL_MAX})`
  );
  const [xl2] = useMediaQuery(
    options['2xl'] || `(min-width: ${BREAKPOINT_2XL_MIN})`
  );

  const variants = {
    ...(md &&
      breakpointValues && {
        ...(breakpointValues['md'] || breakpointValues['base']),
      }),
    ...(lg &&
      breakpointValues && {
        ...(breakpointValues['lg'] || breakpointValues['base']),
      }),
    ...(xl &&
      breakpointValues && {
        ...(breakpointValues['xl'] || breakpointValues['base']),
      }),
    ...(xl2 &&
      breakpointValues && {
        ...(breakpointValues['2xl'] || breakpointValues['base']),
      }),
    ...(sm &&
      breakpointValues && {
        ...(breakpointValues['sm'] || breakpointValues['base']),
      }),
    ...(xs &&
      breakpointValues && {
        ...(breakpointValues['xs'] || breakpointValues['base']),
      }),
  };

  return variants as T;
};
